<script>
export default {
  name: 'action-base',
  data () {
    return {
      actions: []
    }
  },
  methods: {
    registerActions () {
      this.$store.dispatch('Action/setActions', this.actions)
    },
    registerTitle () {
      this.$store.dispatch('setTitle', {title: this.title || ''})
    }
  },
  mounted () {
    this.registerActions()
    this.registerTitle()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ActionBase.vue